export default __webpack_public_path__ + "7e7d40acd8b04771188abf39c5b23ec7.png";